import { ContextlessQueryObserverOptions, useSchemaQuery, useSchemaQueries } from '@frontend/react-query-helpers';
import { SchemaIO } from '@frontend/schema';
import { SchemaCareCreditIntegrationV1Service, serviceName } from '../service';
import { ServiceQueries, ServiceStandardQueries, StandardQueryEndpointName } from '../types';

const DEFAULT_OPTIONS: ContextlessQueryObserverOptions = {
  refetchOnWindowFocus: false,
};

export type UseCareCreditIntegrationV1QueryArgs<
  EndpointName extends StandardQueryEndpointName,
  E = unknown,
  D = SchemaIO<ServiceQueries[EndpointName]>['output']
> = Omit<Parameters<typeof useSchemaQuery<ServiceStandardQueries, EndpointName, E, D>>[0], 'service' | 'serviceName'>;
/**
 * A wrapper around useSchemaQueries that uses the CareCreditIntegrationV1 service and serviceName.
 * This is intended to only be used internally in the `queries` directory of the library and not exported.
 */
export const useCareCreditIntegrationV1Queries = <
  EndpointName extends StandardQueryEndpointName,
  E = unknown,
  D = SchemaIO<ServiceQueries[EndpointName]>['output']
>(
  argsArr: UseCareCreditIntegrationV1QueryArgs<EndpointName, E, D>[]
) =>
  useSchemaQueries<ServiceStandardQueries, EndpointName, E, D>(
    argsArr.map(({ options, ...args }) => ({
      service: SchemaCareCreditIntegrationV1Service,
      serviceName,
      ...args,
      options: {
        ...DEFAULT_OPTIONS,
        ...options,
      },
    }))
  );
